import { axios } from '@/plugins/axios-pol'

const basePath = '/personal/api/EstadoFuerza/personal'

function buildFormData({ idPersonal, idResultado, tipoObservacion, seguimiento, adjunto, id }) {
  const formData = new FormData()
  if (id !== undefined && id !== null) {
    formData.append('Id', id)
  }
  formData.append('fk_idResultado', idResultado)
  formData.append('fk_idPersonal', idPersonal)
  formData.append('tipoObservacion', tipoObservacion)
  formData.append('seguimiento', seguimiento)
  if (adjunto) {
    formData.append('adjunto', adjunto)
  }
  return formData
}

export default class SeguimientoResultadoC3ApiRepository {
  // Recupera todos los seguimientos de un resultado C3
  async getAll(idPersonal, idResultado) {
    const { data } = await axios.get(`${basePath}/${idPersonal}/resultadosPersonalesC3/${idResultado}/seguimientos`)
    return data.data
  }

  // Recupera un seguimiento en específico
  async getById(idPersonal, idResultado, idSeguimiento) {
    const { data } = await axios.get(
      `${basePath}/${idPersonal}/resultadosPersonalesC3/${idResultado}/seguimientos/${idSeguimiento}`
    )
    return data.data
  }

  // Recupera los seguimientos de un resultado C3 filtrados por tipo de observación
  async getByTipo(idPersonal, idResultado, tipoObservacion) {
    const { data } = await axios.get(
      `${basePath}/${idPersonal}/resultadosPersonalesC3/${idResultado}/seguimientos/tipo/${tipoObservacion}`
    )
    return data.data
  }

  // Crea un seguimiento para un resultado C3, con adjunto opcional
  async create(idPersonal, idResultado, seguimiento) {
    const formData = buildFormData({ idPersonal, idResultado, ...seguimiento })
    const { data } = await axios.post(
      `${basePath}/${idPersonal}/resultadosPersonalesC3/${idResultado}/seguimientos`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return data.data
  }

  // Actualiza un seguimiento existente, con adjunto opcional
  async update(idPersonal, idResultado, idSeguimiento, seguimiento) {
    const formData = buildFormData({ idPersonal, idResultado, id: idSeguimiento, ...seguimiento })
    const { data } = await axios.put(
      `${basePath}/${idPersonal}/resultadosPersonalesC3/${idResultado}/seguimientos/${idSeguimiento}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return data.data
  }

  // Elimina lógicamente un seguimiento
  async delete(idPersonal, idResultado, idSeguimiento) {
    await axios.put(
      `${basePath}/${idPersonal}/resultadosPersonalesC3/${idResultado}/seguimientos/${idSeguimiento}/delete`
    )
  }
}
